import { gql } from '@apollo/client';

export const QUERY_CATEGORIES = gql`
  query GetCategoriesWithName {
    categorieproduits {
      data {
        id
        attributes {
          name
        }
      }
    }
  }
`;
